import { render, staticRenderFns } from "./NormalSearchNav210.vue?vue&type=template&id=08b738e2&scoped=true&"
import script from "./NormalSearchNav210.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav210.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b738e2",
  null
  
)

export default component.exports